// @flow

export const TREE = 'soilPointsModule'

export const EDIT_POINT = '@samplingPointsModule/EDIT_POINT'
export const SAVE_GRID_ID = '@samplingPointsModule/SAVE_GRID_ID'
